/* Built In Imports */
// import NextLink from 'next/link';

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */

/* Services */

/**
 *
 * @param {object} topics
 * @returns
 */

const BlogTopics = ({ topics }) => {
  return (
    <>
      <Flex
        w="100%"
        h="auto"
        display="flex"
        flexWrap="wrap"
        gridGap={{ base: '14px', md: '20px' }}
        gridRowGap={{ base: '0', md: '0' }}
        gridColumnGap={{ base: '13px', md: '20px' }}
        pt={{ base: '20px', md: '16px' }}
        // ml={{base:'18px'}}
        // px={{ base: "15px", md: "0" }}
      >
        {topics?.map(topic => (
          <Box
            key={nanoid()}
            w="auto"
            mb={{ base: '15px', md: '20px' }}
            h="auto"
            color="#3B444B"
            fontFamily="Zilla Slab"
            fontStyle="normal"
            fontWeight="400"
            fontSize="14px"
            lineHeight="18.2px"
            /* or 18px */
            padding={{ base: '10px 45px', md: '10px 45px' }}
            borderRadius="8px"
            bg="transparent"
            border=" 1px solid #FBAD18"
            variant="outline"
            textDecor="none"
            _hover={{
              textDecor: 'none',
              variant: 'solid',
              bg: '#FBAD18',
              fontWeight: 500,
              color: '#3B444B',
            }}
            _focus={{
              textDecor: 'none',
              fontWeight: 500,
              variant: 'solid',
              bg: '#FBAD18',
              color: '#3B444B',
            }}
          >
            {topic.title}
          </Box>
        ))}
      </Flex>
    </>
  );
};

export default BlogTopics;
